import { useState, useEffect } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { useEditDemoVideoModalStyles } from "./styles";
import useFetch from "../../../../hooks/useFetch";
import { toast } from "react-toastify";

export const EditDemoVideoModal = ({
  isOpen,
  onClose,
  currentUrl = "",
  onSaveSuccess,
}) => {
  const classes = useEditDemoVideoModalStyles();
  const [url, setUrl] = useState(currentUrl);
  const [error, setError] = useState("");

  const { mutate: saveDemoVideo, loading } = useFetch(
    "/mentor/mock-demo-video",
    { method: "put", manual: true },
  );

  useEffect(() => {
    if (isOpen) {
      setUrl(currentUrl);
      setError("");
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen, currentUrl]);

  const handleSave = async () => {
    if (!url.trim()) {
      setError("Demo link is required");
      return;
    }

    await saveDemoVideo({
      data: { mockDemoVideoUrl: url.trim() },
      onSuccess: (data) => {
        toast.success("Demo video link saved");
        if (onSaveSuccess) onSaveSuccess(data?.mockDemoVideoUrl ?? url.trim());
        onClose();
      },
      onError: () => {
        toast.error("Failed to save demo video link");
      },
    });
  };

  if (!isOpen) return null;

  return (
    <div className={classes.overlay} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <div className={classes.header}>
          <span className={classes.title}>Edit demo video</span>
          <button className={classes.closeBtn} onClick={onClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <div className={classes.fieldGroup}>
          <label className={classes.label}>Demo link</label>
          <input
            className={`${classes.input} ${error ? classes.inputError : ""}`}
            value={url}
            onChange={(e) => {
              setUrl(e.target.value);
              if (error) setError("");
            }}
            placeholder="Enter the drive link or Youtube URL"
          />
          {error && <span className={classes.errorText}>{error}</span>}
        </div>

        <button
          className={classes.saveBtn}
          onClick={handleSave}
          disabled={loading}
        >
          {loading && <span className={classes.spinner} />}
          Save changes
        </button>
      </div>
    </div>
  );
};
